import React, { useEffect, useState } from 'react';

const RestaurantMenu = ({ menuData }) => {
  const [expandedCategories, setExpandedCategories] = useState({});

  useEffect(() => {
    if (menuData && Array.isArray(menuData.categories)) {
      const initialState = menuData.categories.reduce((acc, category) => {
        acc[category.name] = false;
        return acc;
        // All categories start collapsed
      }, {});
      setExpandedCategories(initialState);
    }
  }, [menuData]);

  if (!menuData || !Array.isArray(menuData.categories) || menuData.categories.length === 0) {
    return null;
  }

  const toggleCategory = (name) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const formatPrice = (value) => {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number' && !Number.isNaN(value)) {
      const formatted = value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
      return `£${formatted}`;
    }

    return value;
  };

  const buildPriceLabel = (wine) => {
    const glass = formatPrice(wine.price_glass);
    const bottle = formatPrice(wine.price_bottle);

    if (!glass && !bottle) {
      return null;
    }

    const parts = [];

    if (glass) parts.push(`Glass ${glass}`);
    if (bottle) parts.push(`Bottle ${bottle}`);

    return parts.join(' | ');
  };

  const buildName = (wine) => {
    const nameParts = [wine.producer, wine.name]
      .filter((value) => value && value !== 'N/A' && value !== 'NOT KNOWN');

    if (nameParts.length === 0) {
      return 'Unnamed Wine';
    }

    return nameParts.join(' · ');
  };

  return (
    <div className="restaurant-menu">
      {menuData.categories.map((category) => (
        <div key={category.name} className="menu-category">
          <button
            type="button"
            className={`menu-category-toggle ${expandedCategories[category.name] ? 'open' : ''}`}
            onClick={() => toggleCategory(category.name)}
          >
            <span className="menu-category-name">{category.name}</span>
            <span className="menu-category-meta">
              {category.wines.length} {category.wines.length === 1 ? 'wine' : 'wines'}
            </span>
          </button>
          {expandedCategories[category.name] && (
            <div className="menu-wine-list">
              {category.wines.map((wine, index) => {
                const priceLabel = buildPriceLabel(wine);
                return (
                  <div key={`${category.name}-${index}`} className="menu-wine-card">
                    <div className="menu-wine-header">
                      <div className="menu-wine-title">
                        <span className="menu-wine-name">{buildName(wine)}</span>
                        {wine.vintage && <span className="menu-wine-vintage">{wine.vintage}</span>}
                      </div>
                      {priceLabel && (
                        <div className="menu-wine-prices">{priceLabel}</div>
                      )}
                    </div>
                  <div className="menu-wine-details">
                    {(wine.region || wine.country) && (
                      <span className="menu-wine-region">
                        {[wine.region, wine.country].filter(Boolean).join(', ')}
                      </span>
                    )}
                    {wine.appellation && (
                      <span className="menu-wine-appellation">{wine.appellation}</span>
                    )}
                    {wine.grapes && wine.grapes.length > 0 && (
                      <span className="menu-wine-grapes">{wine.grapes.join(', ')}</span>
                    )}
                  </div>
                </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RestaurantMenu;
